// removed by extract-text-webpack-plugin
module.exports = {"container":"_2UUNhTnd0EWo-1BWfSCx4x"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/CallToAction/styles.scss
 ** module id = 450
 ** module chunks = 0
 **/